// src/components/Layout/Header.js
import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './Header.module.css';

// Aktif rotayı bölüm adına eşle — üst bar her zaman nerede olduğunu söyler.
const SECTION_TITLES = {
  '/': 'Siparişler',
  '/orders': 'Siparişler',
  '/packages': 'Paketler · Ülkeler',
  '/regions-package': 'Paketler · Bölgeler',
  '/lifetime-packages': 'Paketler · Ön Ödemeli',
  '/continents': 'Kıtalar',
  '/countries': 'Ülkeler',
  '/regions': 'Bölgeler',
  '/users': 'Kullanıcılar',
  '/configurations': 'Konfigürasyonlar',
  '/content-management': 'İçerik Yönetimi',
  '/settings': 'Ayarlar',
  '/app-settings': 'Uygulama Ayarları',
};

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login'); // Çıkış yaptıktan sonra login sayfasına yönlendir
  };

  const section = SECTION_TITLES[location.pathname] || 'Konsol';
  const initial = (user?.name || user?.username || 'O').trim().charAt(0).toUpperCase();

  return (
    <header className={styles.header}>
      <nav className={styles.crumb} aria-label="Konum">
        <span className={styles.crumbRoot}>eSIM Konsolu</span>
        <span className={styles.crumbSep} aria-hidden="true">/</span>
        <span className={styles.crumbCurrent}>{section}</span>
      </nav>
      <div className={styles.userInfo}>
        {user && (
          <div className={styles.identity}>
            <span className={styles.avatar} aria-hidden="true">{initial}</span>
            <span className={styles.userName}>{user.name || user.username}</span>
          </div>
        )}
        <button onClick={handleLogout} className={styles.logoutButton}>
          Çıkış yap
        </button>
      </div>
    </header>
  );
};

export default Header;